import React, { useState } from "react";
import { ReactComponent as Arrow } from "../../images/v-arrow.svg";
import { Button } from "antd";
import { IMAGE_BASE_URL } from "../../common/Constants";

const AgentVoucherCard = ({
  AgentDetails,
  AddToCart,
  cartItems,
  RemoveCartItem,
}) => {
  const [activeIndex, setActiveIndex] = useState([]);
  const selectedAgentIds = cartItems?.map((it) => it?.agent_id);
  const selectedVouchers = cartItems?.map((it) => it?.flooring_voucher_id);
  const toggleSection = (id) => {
    setActiveIndex((prevIndices) => {
      if (prevIndices?.includes(id)) {
        const newIndices = prevIndices?.filter((it) => it !== id);
        return newIndices;
      } else {
        return [...prevIndices].concat(id);
      }
    });
  };

  const CartSelect = (agentId, productId, voucherId) => {
    let temp = {
      agent_id: agentId,
      flooring_product_id: productId,
      flooring_voucher_id: voucherId,
    };
    AddToCart(temp);
  };

  const DeleteCart = (id) => {
    RemoveCartItem(id);
  };
  const GetCartId = (Id, type) => {
    if ((type = "agent")) {
      const temp = cartItems?.filter((it) => it?.agent_id == Id);
      return temp[0]?.id;
    } else {
      const temp = cartItems?.filter((it) => it?.flooring_voucher_id == Id);
      return temp[0]?.id;
    }
  };

  return (
    <section className="flooring-full-card-section">
      {AgentDetails &&
        AgentDetails.map((item, index) => (
          <div className="flooring-full-card" key={index}>
            <div className="full-card-header">
              <div className="logo-block">
                <img
                  src={`${IMAGE_BASE_URL}${item?.icon}`}
                  alt=""
                />
              </div>
              <div className="card-header-group">
                <div className="card-header-block">
                  <div className="header-block-list">
                    <h2>{item.name}</h2>
                    <div className="inline-flex">
                      {item.hasPremium ? (
                        <span className="category-list">
                          <img
                            src="/images/prem_icon.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Premium</span>
                        </span>
                      ) : null}
                      {item.featured ? (
                        <span className="category-list">
                          <img
                            src="/images/star.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Featured</span>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="header-block-list">
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_clock.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Approval Time:{" "}
                      <strong className="ml-[5px] font-[600]">
                        {item?.approvalTime}
                      </strong>
                    </p>
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_zap.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Loan to Value:
                      <strong className="ml-[5px] font-[600]">
                        {item?.ltv}
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="card-header-info">
                  <div className="info-header-block-list">
                    <h3 className="info-view-col">
                      Interest Rate (per 30 days)
                      <span>
                        {item.product?.interest_from.slice(
                          0,
                          item.product?.interest_from.indexOf(".") + 2
                        )}
                        % -{" "}
                        {item?.product?.interest_to.slice(
                          0,
                          item.product?.interest_to.indexOf(".") + 2
                        )}
                        %
                      </span>
                    </h3>
                    <h4 className="info-view-col">
                      Admin Fee{" "}
                      <span>
                        ${item?.product?.admin_fee_from.slice(
                          0,
                          item?.product?.admin_fee_from.indexOf(".")
                        )} - $
                        {item?.product?.admin_fee_to.slice(
                          0,
                          item?.product?.admin_fee_to.indexOf(".")
                        )}
                      </span>
                    </h4>
                    <Button
                      type="button"
                      className={`${selectedAgentIds?.includes(item?.id)
                        ? "sav_btn"
                        : "can_btn"
                        }`}
                      onClick={() => {
                        if (selectedAgentIds?.includes(item?.id)) {
                          DeleteCart(GetCartId(item?.id));
                        } else {
                          CartSelect(item?.id, item?.product?.id, "");
                        }
                      }}
                    >
                      {selectedAgentIds?.includes(item?.id)
                        ? "Selected"
                        : "Select"}
                    </Button>
                  </div>{" "}
                </div>
              </div>
            </div>
            {item.vouchers?.length > 0 && (
              <div className="eligible-btn">
                <button
                  className="btn"
                  type="button"
                  onClick={() => toggleSection(item?.id)}
                >
                  Eligible Vouchers
                  <span
                    className={`${activeIndex?.includes(item?.id) ? null : "down-arrow"
                      }`}
                  >
                    <Arrow />
                  </span>
                </button>
              </div>
            )}
            {activeIndex?.includes(item?.id) ? (
              <div className="eligible-voucher-section">
                {item?.vouchers?.length > 0 &&
                  item.vouchers.map((voucher, idx) => (
                    <div className="eligible-voucher-block">
                      <div className="eligible-circle-left" />
                      <div className="eligible-voucher-list">
                        <h2>
                          Interest Rate{" "}
                          <span>
                            {voucher.interest_rate.slice(
                              0,
                              voucher?.interest_rate.indexOf(".") + 2
                            )}
                            %
                          </span>
                        </h2>
                        <h2>
                          {voucher.customer_type?.label}
                          {voucher?.voucher_qty_type?.value == 0 ? (
                            <span>{voucher?.voucher_qty_type?.label}</span>
                          ) : (
                            <span>
                              {voucher?.redeemed_qty}/{voucher?.qty} voucher(s)
                              left
                            </span>
                          )}
                        </h2>
                        <h3>
                          Valid From{" "}
                          <span>
                            {voucher?.start_period} - {voucher?.end_period}
                          </span>
                        </h3>
                        <h3>
                          Eligible Floor Amount{" "}
                          <span>
                            $
                            {voucher.amount_from.slice(
                              0,
                              voucher.amount_from.indexOf(".")
                            )}{" "}
                            - $
                            {voucher?.amount_to.slice(
                              0,
                              voucher.amount_to.indexOf(".")
                            )}
                          </span>
                        </h3>
                        <h4>
                          You Redeemed{" "}
                          <span>
                            {voucher.dealer_redeemed_qty}/
                            {voucher?.max_redemption} times
                          </span>
                        </h4>
                        <Button
                          type="button"
                          className={`${selectedVouchers?.includes(voucher?.id)
                            ? "sav_btn"
                            : "can_btn"
                            }`}
                          onClick={() => {
                            if (selectedVouchers?.includes(voucher?.id)) {
                              DeleteCart(GetCartId(item?.id));
                            } else {
                              CartSelect(
                                item?.id,
                                item?.product?.id,
                                voucher?.id
                              );
                            }
                          }}
                        >
                          {selectedVouchers?.includes(voucher?.id)
                            ? "Applied"
                            : "Apply"}
                        </Button>
                      </div>
                      <div className="eligible-circle-right" />
                    </div>
                  ))}
              </div>
            ) : null}
          </div>
        ))}
    </section>
  );
};

export default AgentVoucherCard;
